<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">消息中心 /</div>
        <div class="box-header-right">
          <div>模板管理</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="st == 1">
      <div class="biaodan">
        <div class="botton-box">
          <el-button size="mini" @click="addTemplate('add')" class="addButton">新增</el-button>
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form :inline="true" label-position="right" class="demo-form-inline" :model="form">
              <el-form-item label="模板CODE">
                <el-input v-model="form.templateCode" clearable style="width: 150px" size="mini"
                  placeholder="请输入模板CODE"></el-input>
              </el-form-item>
              <el-form-item label="模板内容">
                <el-input v-model="form.templateContent" clearable style="width: 150px" size="mini"
                  placeholder="请输入发送内容"></el-input>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button type="primary" @click="onSearch" class="search" size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table class="disTable" ref="multipleTable" align="center" max-height="650" :header-cell-style="{
      background: '#F3F8FE',
      color: '#333333 ',
      textAlign: 'center',
    }" :cell-style="{ textAlign: 'center' }" :data="tableData">
              <el-table-column align="center" prop="templateCode" label="模板CODE" width="300"
                :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="templateName" label="模板标题" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="templateContent" label="模板内容" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="templateType" label="模板类型">
                <template slot-scope="scope">
                  <div v-for="(item, index) in templateTypeList" :key="index">
                    <div v-if="item.value == scope.row.templateType">{{ item.label }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                  <el-button style="margin-left: 10px;color:#008DD6" type="text"
                    @click="addTemplate('edit', scope.row)">编辑</el-button>
                  <el-popconfirm title="确定删除吗？" type="text" trigger="click" @confirm="deletetem(scope.row)">
                    <el-button type="text" slot="reference" style="margin-left: 10px;color:#ED6363 ">删除</el-button>
                  </el-popconfirm>
                  <el-button style="margin-left: 10px;color:#008DD6" type="text"
                    @click="sendOut(scope.row)">发送</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper"
            :total="total" background :page-size="page.size" :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange" :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"></el-pagination>
        </div>
      </div>
      <el-dialog :title="title" :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false">
        <div>
          <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item prop="templateCode" label="模板CODE">
              <el-input v-model="formData.templateCode" placeholder="模板CODE"></el-input>
            </el-form-item>
            <el-form-item label="模板标题" prop="templateName">
              <el-input v-model="formData.templateName" placeholder="模板标题"></el-input>
            </el-form-item>
            <el-form-item label="模板类型" prop="templateType">
              <el-select size="medium" placeholder="请选择模板类型" clearable filterable v-model="formData.templateType"
                @change="qeihuan">
                <el-option v-for="item in templateTypeList" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板内容">
              <quill-editor class="editor" v-if="formData.templateType != 2" v-model="formData.templateContent"
                ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                @change="onEditorChange($event)">
              </quill-editor>
              <el-input type="textarea" v-else :rows="10" v-model="formData.templateContent"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="mini">关闭</el-button>
          <el-button type="primary" class="search" size="mini" @click="cancelcerat">
            <span>确 定</span>
          </el-button>
        </span>
      </el-dialog>
      <el-dialog :title="title" :visible.sync="dialogVisibleTwo" :modal="true" :close-on-click-modal="false">
        <div>
          <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="模板标题">
              <el-input v-model="formData.templateName" disabled placeholder="模板标题"></el-input>
            </el-form-item>
            <el-form-item label="模板内容">
              <el-input type="textarea" disabled :rows="6" v-model="formData.templateContent"></el-input>
            </el-form-item>
            <el-form-item label="测试数据">
              <el-input type="textarea" :rows="6" v-model="ruleFormTwo.testData"></el-input>
            </el-form-item>
            <el-form-item label="消息类型">
              <el-select size="medium" placeholder="请选择消息类型" clearable filterable v-model="ruleFormTwo.msgType">
                <el-option v-for="item in templateTypeList" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消息接收方">
              <el-select size="medium" placeholder="请选择消息类型" multiple  clearable filterable v-model="ruleFormTwo.receiver">
                <el-option v-for="item in UserArrayList" :key="item.id" :label="item.accountName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleTwo = false" size="mini">关闭</el-button>
          <el-button type="primary" class="search" size="mini" @click="sendMessage">
            <span>确 定</span>
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { workflowTaskComplete } from "@/api/processManagement";
import {
  getMsgTemplateList,
  setMsgTemplateAdd,
  setMsgTemplateEdit,
  setMsgTemplateSendMsg,
  getUserList2
} from "../../../api/systemManagement";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请输入模板内容', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
        syntax: true, //语法检测
      },
      seeXML: '',
      content: '',
      timer: '',
      seqIdsList: [],
      tableDataTwo: [],
      dialogVisibleTwo: false,
      currentPageTwo: '1',
      dialogVisible: false,
      st: 1,
      value: '',
      totalTwo: '',
      ruleForm: {
        projectName: '',
        projectCode: '',
        status: 1,
        remark: '',
        id: '',
        managerId: '',
        managerName: ''
      },
      entryList: [],
      optionList: [],
      total: null,
      title: '添加模板',
      titleTwo: '查看项目基本信息',
      currentPage: 1,
      type: '',
      form: {
        templateCode: "",
        templateContent: "",
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        templateCode: '',
        templateContent: '',
        templateName: '',
        templateType: null,
        id: null,
      },
      ruleFormTwo: {
        templateCode: '',
        receiver: [],
        msgType: '',
        testData: '',
      },
      UserArrayList: [],
      pageTwo: {
        page: 1,
        size: 10
      },
      templateTypeList: [
        { label: '系统', value: 1 },
        { label: '短信', value: 2 },
        { label: '邮件', value: 3 },
      ],
      rules: {
        templateCode: [
          { required: true, message: '请输入模板CODE', trigger: 'blur' },
        ],
        templateName: [
          { required: true, message: '请输入模板标题', trigger: 'blur' },
        ],
        templateType: [
          { required: true, message: '请选择模板类型', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.queryDictionaries()
    this.getUserList2Fun()
    this.st = 1
  },
  methods: {
    //发送消息
    async sendMessage() {
      let params = {
        msgType: this.ruleFormTwo.msgType,
        receiver: this.ruleFormTwo.receiver,
        templateCode: this.ruleFormTwo.templateCode,
        testData: this.ruleFormTwo.testData
      }
      const res = await setMsgTemplateSendMsg(params)
      if (res.data.code == 200) {
        this.$message({
          message: '发送成功',
          type: 'success'
        });
        this.queryDictionaries()
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: 'warning'
        });
      }
      this.dialogVisibleTwo = false
    },
    sendOut(val) {
      this.ruleFormTwo.templateCode = val.templateCode
      this.formData.templateName = val.templateName
      this.formData.templateContent = val.templateContent
      this.ruleFormTwo.testData = ''
      this.dialogVisibleTwo = true
    },
    deletetem(val) {
      if ((this.total - 1) % this.page.size === 0) {
        if (this.page.page > 1) {
          this.page.page -= 1
        }
      }
      this.$axios.delete(`/msg/template/delete/${val.id}`).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.queryDictionaries()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      })
    },
    qeihuan(val) {
      if (val == 2) {
        this.formData.templateContent = ''
      }
    },
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
      this.$emit("input", this.content);
    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.code == 200) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.result.url);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    // 新增或修改模板
    async cancelcerat() {
      let xx = true
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          xx = true
        } else {
          xx = false
        }
      });
      if (xx == false) {
        this.$message({
          message: '请输入或选择必填项',
          type: 'warning'
        });
        return false;
      }
      if (this.type == 'add') {
        let params = {
          templateCode: this.formData.templateCode,
          templateContent: this.formData.templateContent,
          templateName: this.formData.templateName,
          templateType: this.formData.templateType,
        }
        const res = await setMsgTemplateAdd(params)
        if (res.data.code == 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.queryDictionaries()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      } else {
        let params = {
          templateCode: this.formData.templateCode,
          templateContent: this.formData.templateContent,
          templateName: this.formData.templateName,
          templateType: this.formData.templateType,
          id: this.formData.id,
        }
        const res = await setMsgTemplateEdit(params)
        if (res.data.code == 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.queryDictionaries()
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: 'warning'
          });
        }
      }
    },
    addTemplate(val, item) {
      if (val == 'add') {
        this.title = "添加模板"
        this.formData.templateContent = ''
        this.formData.templateCode = ''
        this.formData.templateName = ''
        this.formData.templateType = 1
        this.type = val
      } else {
        this.type = val
        this.title = "编辑模板"
        this.formData.templateContent = item.templateContent
        this.formData.templateCode = item.templateCode
        this.formData.templateName = item.templateName
        this.formData.templateType = item.templateType
        this.formData.id = item.id
      }
      this.dialogVisible = true
    },
    getValueDialog(val) {
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.queryDictionaries();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.queryDictionaries();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.queryDictionaries()
    },
    // 获取用户
    async getUserList2Fun() {
      let params = {
        deptId: JSON.parse(sessionStorage.getItem('userInfo')).deptId,
        page: 1,
        size: 99999,
        queryRole:true,
        zcUserTypeLike: "gov"
      }
      const res = await getUserList2(params);
      this.UserArrayList = res.data.data.dataList
    },
    // 查询项目列表
    async queryDictionaries() {
      let params = {
        templateCode: this.form.templateCode,
        templateContent: this.form.templateContent,
        pageNo: this.page.page,
        pageSize: this.page.size,
      }
      const res = await getMsgTemplateList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
        this.tableData.map((item) => {
          item.templateType = Number(item.templateType)
        })
      }
    },
  },
}
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}

.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #D8D8D8;
}

.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

/deep/ .el-dialog__footer {
  margin-top: 20px;
}

.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #B2B3C9;
  line-height: 21px;
  display: flex;
  align-items: center;
}

.box-header-right {
  font-weight: 400;
  color: #004AD1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

.section {
  height: 94.9%;
  background-color: #fff;
}

.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}

.el-menu-item:hover {
  color: #1e90ff;
}

.daohang {
  display: flex;
  margin-left: 15px;
}

.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}

.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biaodan-left .el-form-item {
  margin-bottom: 0px;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}

.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}

/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}

.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-item {
  display: flex;
  justify-content: left;
}

.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}

.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}

//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}

.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}

.aside .el-button {
  padding: 0;
}

.editor {
  line-height: normal !important;
  height: 300px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}
</style>



// WEBPACK FOOTER //
// src/pages/messageCenter/templateManage/index.vue